<template>
  <v-form ref="form">
    <v-container class="limited" grid-list-xl>
      <v-layout row wrap fill-height>
        <v-flex xs12 md4>
          <v-card class="pa-4 elevation-5" column height="100%">
            <v-flex xs12>
              <v-layout column>
                <v-layout row wrap align-center justify-space-between="">
                  <h4 class="subheading font-weight-black primary--text pl-2">
                    Movimento
                  </h4>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 class="py-0">
                    <v-text-field
                      name="id"
                      label="ID Movimento"
                      type="text"
                      v-model="movimento.id"
                      required
                      :disabled="true"
                      data-cy="idField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 class="py-0">
                    <v-text-field
                      name="dataCriacao"
                      label="Data de Criação"
                      type="text"
                      v-model="movimento.dataCriacao"
                      required
                      v-mask="'##/##/####'"
                      :masked="true"
                      :disabled="true"
                      data-cy="dataCriacaoField"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="py-0">
                    <v-text-field
                      name="status"
                      label="Status"
                      type="text"
                      v-model="movimento.status"
                      required
                      :disabled="true"
                      data-cy="cpfField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 md8>
          <v-card class="pa-4 elevation-5" column height="100%">
            <v-flex xs12>
              <v-layout column>
                <v-layout row wrap align-center justify-space-between="">
                  <h4 class="subheading font-weight-black primary--text pl-2">
                    2ª Via Carteirinha
                  </h4>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nome"
                      label="Motivo"
                      type="text"
                      v-model="motivoSegundaVia"
                      required
                      :disabled="true"
                      data-cy="nomeField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12 lg8 class="py-0">
                    <v-text-field
                      name="nomeMae"
                      label="Justificativa"
                      type="text"
                      v-model="segundaViaCartao.justificativa"
                      :disabled="true"
                      required
                      data-cy="nomeMaeField"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Anexos
                </h4>
                <v-data-table
                  :headers="headers"
                  :items="movimentoAnexos"
                  :pagination.sync="pagination"
                  :total-items="movimentoAnexos.length"
                  :loading="isLoading"
                  :rows-per-page-items="[5, 10, 25]"
                  no-data-text="Não há registros"
                  rows-per-page-text="Linhas por página"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.anexo.filename }}</td>
                    <td>{{ props.item.tipoAnexo.descricao }}</td>
                    <td>
                      <v-btn
                        flat
                        small
                        color="green"
                        @click="
                          downloadMovimentoAnexo(props.item.anexo.arquivoId)
                        "
                        >Baixar</v-btn
                      >
                    </td>
                  </template>
                </v-data-table>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="movimento.observacoesSolicitante">
          <v-card class="pa-4 elevation-5" column>
            <v-flex xs12>
              <v-layout column>
                <h4 class="subheading font-weight-black primary--text">
                  Observações
                </h4>
                <v-layout row wrap>
                  <v-flex class="py-0">
                    <v-text-field
                      type="text"
                      disabled
                      v-model="movimento.observacoesSolicitante"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
      <loading-dialog
        :show="isLoading"
        :message="loadingMessage"
      ></loading-dialog>
    </v-container>
  </v-form>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { mask } from "vue-the-mask";

import { formataData } from "@/utils/formataValores";

import LoadingDialog from "@/components/LoadingDialog";

import {
  getMovimento,
  listarMovimentoAnexos,
  getSegundaViaCartao,
  downloadAnexoMovimento
} from "@/services/movimentos";

import { download } from "@/utils/download";

const { mapState } = createNamespacedHelpers("beneficiario");
const { mapMutations } = createNamespacedHelpers("portal");

export default {
  name: "UpdateRegistration",
  directives: { mask },
  components: {
    LoadingDialog
  },
  computed: mapState(["dadosBeneficiario"]),
  data() {
    return {
      isLoading: false,
      loadingMessage: null,
      statusMovimento: null,
      motivoSegundaVia: null,
      movimento: [],
      segundaViaCartao: [],
      movimentoAnexos: [],
      headers: [
        { text: "Nome do Arquivo", value: "nomeArquivo", sortable: false },
        { text: "Tipo", value: "tipo", sortable: false },
        {
          text: "",
          value: "downloadId",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  created() {
    this.getSegundaViaCartao();
  },
  methods: {
    ...mapMutations(["setErrorToast", "setToast"]),
    async getMovimento() {
      const movimentoId = this.$route.params.id;
      await getMovimento(movimentoId).then(response => {
        this.movimento = {
          ...response,
          dataCriacao: formataData(response.dataCriacao, "DD/MM/YYYY"),
          status: response?.statusMovimento?.descricao
        };
      });
    },
    async getSegundaViaCartao() {
      const movimentoId = this.$route.params.id;

      this.isLoading = true;

      await getSegundaViaCartao(movimentoId)
        .then(({ data, errors }) => {
          if (errors && errors.length) {
            const errorMessage = errors[0].message.split(": ")[1];

            this.setErrorToast(errorMessage);
          } else {
            const segundaVia = data.segundaViaCartao;

            if (segundaVia) {
              if (segundaVia.codigoBeneficiario === this.dadosBeneficiario.id) {
                this.segundaViaCartao = segundaVia;
                this.motivoSegundaVia = segundaVia.motivoSegundaVia?.descricao;

                this.getMovimento();
                this.listarMovimentoAnexos();
              } else {
                this.setToast(
                  "Você não tem permissão para acessar esse movimento"
                );
              }
            }
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async listarMovimentoAnexos() {
      const movimentoId = this.$route.params.id;
      await listarMovimentoAnexos(movimentoId).then(response => {
        this.movimentoAnexos = response;
      });
    },
    downloadMovimentoAnexo(movimentoArquivoId) {
      if (movimentoArquivoId === null) {
        this.setToast("Anexo do movimento indisponível para download");
      } else {
        downloadAnexoMovimento(movimentoArquivoId).then(({ headers, data }) => {
          if (data?.error) {
            const errorMessage = data.message;

            this.setErrorToast(errorMessage);
          } else {
            const filename = headers["content-disposition"].replace(
              "attachment; filename=",
              ""
            );

            download(data, filename);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.container.grid-list-xs .layout .flex {
  padding: 1px !important;
}
</style>
